export default __webpack_public_path__ + "static/media/bh.8099d018.svg";